import './create';
import './list';
import './detail';
import './edit';
import './submit-quote';
import './incoming-quotes-single-listing';